import React from 'react'
import PropTypes from 'prop-types'
import logoFooter from '../../../_static/images/logo_footer.png'
import {outerUrls} from '../../../settings/routes'
import visaLogoNew from '../../../_static/images/visa-logo-new.png'
import masterCardLogo from '../../../_static/images/mastercard_logo1.png'


let FooterTop = (props, context) => {
    let {formatMessage} = context
    return (
        <div className="footer_top">
            <div className="container">
                <div className="footer_top_left">
                    <a href={outerUrls.home} target="_blank"><img src={logoFooter} alt="QBM" /></a>
                    <div className="slog_footer">{formatMessage('Question Bank Manager')}</div>

                    {/* <div className="pre-footer__logo-content hidden-xs">
                        <div className="pre-footer__logo-fld pre-footer__logo-fld--size pre-footer__logo-fld--space">
                            <img src={visaLogoNew} alt="VISA" />
                        </div>
                        <div className="pre-footer__logo-fld pre-footer__logo-fld--size pre-footer__logo-fld--space">
                            <img src={masterCardLogo} alt="MASTERCARD" />
                        </div>
                    </div> */}
                </div>
                <div className="footer_top_right">
                    <div className="footer_right_col">
                        <h4>{formatMessage('COMPANY')}</h4>
                        <ul>
                            <li>
                                <a href={outerUrls.home} target="_blank">{formatMessage('Home')}</a>
                            </li>
                            <li>
                                <a href={outerUrls.about} target="_blank">{formatMessage('About')}</a>
                            </li>
                            <li>
                                <a href={outerUrls.contactUs} target="_blank">{formatMessage('Contact Us')}</a>
                            </li>
                        </ul>
                    </div>
                    <div className="footer_right_col">
                        <h4>{formatMessage('INFORMATION')}</h4>
                        <ul>
                            <li>
                                <a href={outerUrls.faq} target="_blank">{formatMessage('FAQ')}</a>
                            </li>
                            <li>
                                <a href={outerUrls.termsOfUse} target="_blank">{formatMessage('Terms of Use')}</a>
                            </li>
                            <li>
                                <a href={outerUrls.privacyPolicy} target="_blank">{formatMessage('Privacy Policy')}</a>
                            </li>
                        </ul>
                    </div>
                    <div className="footer_right_col">
                        <h4>{formatMessage('SOCIAL')}</h4>
                        <ul>
                            <li>
                                <a href={outerUrls.facebook} target="_blank">{formatMessage('Facebook')}</a>
                            </li>
                            <li>
                                <a href={outerUrls.twitter} target="_blank">{formatMessage('Twitter')}</a>
                            </li>
                            <li>
                                <a href={outerUrls.youtube} target="_blank">{formatMessage('YouTube')}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div
                    className="pre-footer__logo-content hidden-sm hidden-md hidden-lg pre-footer__logo-content--xs-top-offset">
                    <div className="pre-footer__logo-fld pre-footer__logo-fld--size pre-footer__logo-fld--space">
                        <img src={visaLogoNew} alt="VISA" />
                    </div>
                    <div className="pre-footer__logo-fld pre-footer__logo-fld--size pre-footer__logo-fld--space">
                        <img src={masterCardLogo} alt="MASTERCARD" />
                    </div>
                </div>
                <div className="clear"></div>
            </div>
        </div>
    )
}

FooterTop.contextTypes = {formatMessage: PropTypes.any}


export default FooterTop


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Footer/FooterTop.js